import { StaffProfileMock } from "../types/staff-profile.types";

export const defaultStaffProfileMock: StaffProfileMock = {
  summary: {
    tenure: "5 yrs 1 mo",
    currentCtc: "18.0 L",
    lastAppraisal: "4.2 / 5",
    leaveBalance: "14 days",
  },
  overview: {
    employmentSnapshot: [
      { label: "Employment Mode", value: "Permanent" },
      { label: "Employee Type", value: "Full Time" },
      { label: "Sub Department", value: "Delivery" },
      { label: "Work Mode", value: "Hybrid" },
      { label: "Work Location", value: "-" },
      { label: "Grade / Band", value: "B3" },
      { label: "Notice Period", value: "60 days" },
    ],
    recentActivity: [
      { title: "Leave request approved - Casual, 2 days", date: "18-Jul-2026" },
      { title: "Payslip generated for Jun-2026", date: "01-Jul-2026" },
      { title: "Goal API v2 migration updated to 80%", date: "24-Jun-2026" },
      { title: "Increment letter FY 2024 issued", date: "08-Apr-2025" },
    ],
  },
  personal: {
    basicInformation: [
      { label: "Employee ID", value: "-" },
      { label: "Full Name", value: "-" },
      { label: "Gender", value: "Male" },
      { label: "Date of Birth", value: "14-Aug-1993" },
      { label: "Nationality", value: "Indian" },
      { label: "Marital Status", value: "Married" },
      { label: "Blood Group", value: "O+" },
      { label: "Photo Upload", value: "-" },
    ],
    contactDetails: [
      { label: "Official Email", value: "shivaraman.s@robotico.com" },
      { label: "Personal Email", value: "shivaraman93@gmail.com" },
      { label: "Mobile Number", value: "+91 98840 12345" },
      { label: "Emergency Contact Name", value: "Lakshmi S" },
      { label: "Emergency Contact Number", value: "+91 98407 66554" },
      { label: "Emergency Contact Relationship", value: "Spouse" },
    ],
    presentAddress:
      "14/2, Lake View Street, Velachery,\nChennai, Tamil Nadu - 600042",
    permanentAddress:
      "21, Bharathi Nagar, Srirangam,\nTiruchirappalli, Tamil Nadu - 620006",
    dependents: [
      {
        name: "Lakshmi S",
        relationship: "Spouse",
        dateOfBirth: "02-Feb-1995",
        coveredInInsurance: "Yes",
      },
      {
        name: "Advik S",
        relationship: "Son",
        dateOfBirth: "19-Nov-2022",
        coveredInInsurance: "Yes",
      },
    ],
  },
  experienceQualifications: {
    priorExperience: [
      { label: "Total Experience Prior to Joining", value: "-" },
      { label: "Overall Experience", value: "-" },
    ],
    previousEmploymentHistory: [],
    educationalQualifications: [
      { label: "Highest Qualification", value: "-" },
      { label: "Institution / University", value: "-" },
      { label: "Year of Passing", value: "-" },
      { label: "Specialization", value: "-" },
    ],
    skills: [
      { label: "Primary Skill(s)", value: "-" },
      { label: "Secondary Skill(s)", value: "-" },
      { label: "Skill Proficiency Level", value: "-" },
    ],
  },
  job: {
    workDetails: [
      { label: "Entity", value: "-" },
      { label: "Employment Mode", value: "Permanent" },
      { label: "Employee Type", value: "Full Time" },
      { label: "Staff Status", value: "-" },
      { label: "Vendor Name", value: "-" },
      { label: "Vendor Employee ID", value: "-" },
      { label: "Vendor Employment Mode", value: "-" },
      { label: "Cost to RD", value: "-" },
      { label: "Designation", value: "Senior Software Engineer" },
      { label: "Role", value: "Full Stack Developer" },
      { label: "Date of Joining", value: "01-Jul-2021" },
      { label: "Next Review Date", value: "01-Jul-2021" },
      { label: "Probation End Date", value: "-" },
      { label: "Contract Start Date", value: "-" },
      { label: "Contract End Date", value: "-" },
      { label: "Last Working Day", value: "-" },
      { label: "Department", value: "Delivery" },
      { label: "Sub Department", value: "Delivery" },
      { label: "RD Manager", value: "Swapnil" },
      { label: "Client Manager", value: "-" },
      { label: "Notice Period", value: "60 days" },
      { label: "Work Mode", value: "Hybrid" },
      { label: "Work Location", value: "-" },
      { label: "Grade / Band", value: "B3" },
    ],
    positionHistory: [
      {
        effectiveFrom: "01-Apr-2023",
        designation: "Senior Software Engineer",
        reportingTo: "Swapnil",
      },
      {
        effectiveFrom: "01-Apr-2022",
        designation: "Software Engineer II",
        reportingTo: "Swapnil",
      },
      {
        effectiveFrom: "01-Jul-2021",
        designation: "Software Engineer",
        reportingTo: "Venkata Krishna Murthy Gullapalli",
      },
    ],
  },
  onboarding: {
    completedOn: "05-Jul-2021",
    checklist: [
      { title: "Offer & appointment letter signed", date: "01-Jul-2021" },
      { title: "ID & educational documents collected", date: "28-Jun-2021" },
      { title: "Background verification cleared", date: "28-Jun-2021" },
      { title: "Bank account & PF (UAN) setup", date: "02-Jul-2021" },
      { title: "Email & system access provisioned", date: "01-Jul-2021" },
      { title: "Laptop & access card issued", date: "01-Jul-2021" },
      { title: "HR induction & policy sign-off", date: "01-Jul-2021" },
      { title: "Insurance enrollment completed", date: "05-Jul-2021" },
    ],
    offerPreJoining: [
      { label: "Offer Released", value: "10-Jun-2021" },
      { label: "Offer Accepted", value: "15-Jun-2021" },
      { label: "Source of Hire", value: "Employee Referral" },
      { label: "Recruiter", value: "Priya Nair" },
    ],
    backgroundVerification: [
      { label: "Status", value: "Clear - Verified" },
      { label: "Completed On", value: "28-Jun-2021" },
      { label: "Agency", value: "SecureCheck India" },
      { label: "Report", value: "BGV_Report_RDM10138.pdf" },
    ],
    induction: [
      { label: "HR Induction", value: "01-Jul-2021 - Completed" },
      { label: "Buddy Assigned", value: "Prajna Sudip M" },
    ],
  },
  documents: {
    categories: [
      {
        key: "id-proofs",
        label: "ID Proofs",
        count: 3,
        files: [
          { fileName: "PAN_Card.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
          { fileName: "Aadhaar_Card.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
          { fileName: "Passport.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
        ],
      },
      {
        key: "education",
        label: "Educational Certificates",
        count: 3,
        files: [
          { fileName: "Degree_Certificate.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
          { fileName: "HSC_Marksheet.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
          { fileName: "SSLC_Marksheet.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
        ],
      },
      {
        key: "previous-employment",
        label: "Previous Employment",
        count: 3,
        files: [
          { fileName: "Relieving_Letter.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
          { fileName: "Experience_Letter.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
          { fileName: "Last_Payslip.pdf", uploadedOn: "28-Jun-2021", uploadedBy: "Shivaraman S" },
        ],
      },
      {
        key: "payslips",
        label: "Payslips",
        count: 4,
        files: [
          { fileName: "Payslip_Mar_2026.pdf", uploadedOn: "01-Apr-2026", uploadedBy: "HR Ops" },
          { fileName: "Payslip_Apr_2026.pdf", uploadedOn: "01-May-2026", uploadedBy: "HR Ops" },
          { fileName: "Payslip_May_2026.pdf", uploadedOn: "01-Jun-2026", uploadedBy: "HR Ops" },
          { fileName: "Payslip_Jun_2026.pdf", uploadedOn: "01-Jul-2026", uploadedBy: "HR Ops" },
        ],
      },
      {
        key: "others",
        label: "Others",
        count: 3,
        files: [
          { fileName: "NDA.pdf", uploadedOn: "01-Jul-2021", uploadedBy: "HR Ops" },
          { fileName: "Policy_Acknowledgement.pdf", uploadedOn: "01-Jul-2021", uploadedBy: "HR Ops" },
          { fileName: "Insurance_Form.pdf", uploadedOn: "05-Jul-2021", uploadedBy: "HR Ops" },
        ],
      },
    ],
  },
  letters: {
    issued: [
      { letter: "Offer Letter", referenceNo: "RD/OFR/2021/0483", issuedOn: "10-Jun-2021", issuedBy: "Priya Nair" },
      { letter: "Appointment Letter", referenceNo: "RD/APT/2021/0512", issuedOn: "01-Jul-2021", issuedBy: "HR Ops" },
      { letter: "Increment Letter - FY 2021", referenceNo: "RD/INC/2022/0198", issuedOn: "15-Apr-2022", issuedBy: "HR Ops" },
      { letter: "Promotion Letter - Sr. Software Engineer", referenceNo: "RD/PRM/2023/0074", issuedOn: "01-Apr-2023", issuedBy: "HR Ops" },
      { letter: "Increment Letter - FY 2023", referenceNo: "RD/INC/2024/0221", issuedOn: "10-Apr-2024", issuedBy: "HR Ops" },
      { letter: "Increment Letter - FY 2024", referenceNo: "RD/INC/2025/0189", issuedOn: "08-Apr-2025", issuedBy: "HR Ops" },
    ],
  },
  compensation: {
    currentAnnualCtc: "₹18,00,000",
    ctcPeriod: "/ year",
    effectiveFrom: "01-Apr-2025",
    payroll: "Robotico Digital Pvt Ltd",
    breakdown: [
      { label: "Basic Salary", amount: "₹7,20,000" },
      { label: "House Rent Allowance", amount: "₹2,88,000" },
      { label: "Special Allowance", amount: "₹4,82,400" },
      { label: "Flexible Benefits", amount: "₹1,20,000" },
      { label: "Provident Fund (Employer)", amount: "₹86,400" },
      { label: "Gratuity", amount: "₹34,600" },
      { label: "Variable Pay (at 100%)", amount: "₹68,600" },
    ],
    salaryRevisionHistory: [
      { effectiveFrom: "01-Apr-2025", annualCtc: "₹18,00,000", change: "+11.1%", reason: "Annual increment" },
      { effectiveFrom: "01-Apr-2024", annualCtc: "₹16,20,000", change: "+11.7%", reason: "Annual increment" },
      { effectiveFrom: "01-Apr-2023", annualCtc: "₹14,50,000", change: "+26.1%", reason: "Promotion - Sr. Software Engineer" },
      { effectiveFrom: "01-Apr-2022", annualCtc: "₹11,50,000", change: "+19.8%", reason: "Annual increment" },
      { effectiveFrom: "01-Jul-2021", annualCtc: "₹9,60,000", change: "-", reason: "Joining CTC" },
    ],
    note: "Payslips are available under Documents - Payslips",
  },
  
  assets: {
    issued: [
      { asset: "Laptop", assetTag: "RD-LAP-214", serialNo: "C02XEUITSS", issuedOn: "10-Jun-2021", returnOn: "-",status: "IN USE"},
      { asset: "Laptop", assetTag: "RD-LAP-215", serialNo: "C02XRUITSS", issuedOn: "10-Jun-2021", returnOn: "-",status: "IN USE"},
      { asset: "Laptop", assetTag: "RD-LAP-216", serialNo: "C02XXYITSS", issuedOn: "10-Jun-2021", returnOn: "-",status: "IN USE"},
      { asset: "Laptop", assetTag: "RD-LAP-217", serialNo: "C02XXIITSS", issuedOn: "10-Jun-2021", returnOn: "-",status: "IN USE"},
      { asset: "Laptop", assetTag: "RD-LAP-218", serialNo: "C02XXUNTSS", issuedOn: "10-Jun-2021", returnOn: "-",status: "IN USE"},
      { asset: "Laptop", assetTag: "RD-LAP-219", serialNo: "C02XXUIMSS", issuedOn: "10-Jun-2021", returnOn: "-",status: "IN USE"},
    ],
  },
  
  leave: {
    balance: [
      {
        type: "Casual Leave",
        used: 6,
        total: 12,
      },
      {
        type: "Sick Leave",
        used: 4,
        total: 10,
      },
      {
        type: "Earned Leave",
        used: 11,
        total: 18,
      },
      {
        type: "Comp Off",
        used: 2,
        total: 4,
      }
    ],

    recentRequests: [
      {
        type: "Casual",
        dates: "03-Aug-2026 – 04-Aug-2026",
        days: 2,
        status: "Pending",
      },
      {
        type: "Casual",
        dates: "17-Jul-2026",
        days: 1,
        status: "Approved",
      },
      {
        type: "Sick",
        dates: "08-Jun-2026 – 09-Jun-2026",
        days: 2,
        status: "Approved",
      },
      {
        type: "Earned",
        dates: "11-May-2026 – 15-May-2026",
        days: 5,
        status: "Approved",
      },
    ],

    attendanceSummary: [
      {
        label: "Days Present",
        value: "228",
      },
      {
        label: "Leaves Taken",
        value: "17",
      },
      {
        label: "Work From Home",
        value: "61 Days",
      },
      {
        label: "Loss of Pay",
        value: "0 Days",
      },
      {
        label: "Avg Weekly Hours",
        value: "41.5 Hrs",
      },
      {
        label: "Late Check-ins",
        value: "3",
      },
    ],
  },

  performance: {
    appraisalHistory: [
      {
        cycle: "FY 2025",
        reviewedBy: "Anoop Kabade",
        rating: "4.2 / 5",
        remarks: "Led API v2 migration; strong ownership and mentoring",
        outcome: "11.1% Increment",
      },
      {
        cycle: "FY 2024",
        reviewedBy: "Anoop Kabade",
        rating: "4.0 / 5",
        remarks: "Consistent delivery across 3 client releases",
        outcome: "11.7% Increment",
      },
      {
        cycle: "FY 2023",
        reviewedBy: "Anoop Kabade",
        rating: "4.5 / 5",
        remarks: "Exceeded expectations; promotion recommended",
        outcome: "Promotion + 26.1%",
      },
      {
        cycle: "FY 2022",
        reviewedBy: "V. K. Murthy Gullapalli",
        rating: "3.8 / 5",
        remarks: "Solid first year; growing full-stack breadth",
        outcome: "19.8% Increment",
      },
    ],
    goals: [
      {
        title: "API v2 Migration",
        description: "Migrate legacy services to the v2 gateway",
        progress: 80,
      },
      {
        title: "Mentor Two Junior Engineers",
        description: "Weekly 1:1s and code review coverage",
        progress: 100,
      },
      {
        title: "Reduce P1 Defect Rate by 30%",
        description: "Delivery squad quality initiative",
        progress: 65,
      },
    ],
  },
  timeline: [
  {
    date: "12-Nov-2025",
    title: "Appraisal completed — 4.2 / 5",
    description: "FY 2025 cycle · Reviewed by Anoop Kabade",
  },
  {
    date: "08-Apr-2025",
    title: "Salary revision",
    description: "Annual increment · CTC revised to ₹18.0 L",
  },
  {
    date: "10-Apr-2024",
    title: "Salary revision",
    description: "Annual increment · CTC revised to ₹16.2 L",
  },
  {
    date: "01-Apr-2023",
    title: "Promoted to Senior Software Engineer",
    description: "Promotion cycle FY 2022 · CTC revised to ₹14.5 L",
  },
  {
    date: "15-Apr-2022",
    title: "Salary revision",
    description: "Annual increment · CTC revised to ₹11.5 L",
  },
  {
    date: "05-Jul-2021",
    title: "Onboarding completed",
    description: "All 8 checklist items closed by HR Ops",
  },
  {
    date: "01-Jul-2021",
    title: "Joined Robotico",
    description:
      "Onboarded as Software Engineer · Delivery · Employee ID RDM10138",
  },
  {
    date: "15-Jun-2021",
    title: "Offer accepted",
    description: "Accepted via candidate portal",
  },
  {
    date: "10-Jun-2021",
    title: "Offer released",
    description:
      "Software Engineer · Delivery · Offer Ref RD/OFR/2021/0483",
  },
],
  exit: {
  exitReason: "Resignation",
  exitType: "Resignation",
  rehireEligible: "Yes",
  fullAndFinalSettlementStatus: "Pending",
}
};
